import React, { useEffect, useState } from 'react';
import '../Custom.css';

const HasDoneEventDrawer = ({ isOpen, onClose, onSave, initialData }) => {
  const [eventName, setEventName] = useState(initialData?.eventConfig?.eventName || '');
  const [eventProperties, setEventProperties] = useState(initialData?.eventConfig?.eventProperties || []);
  const [lookbackPeriod, setLookbackPeriod] = useState(initialData?.eventConfig?.lookbackPeriod || '7');
  const [lookbackUnit, setLookbackUnit] = useState(initialData?.eventConfig?.lookbackUnit || 'days');

  useEffect(() => {
    if (initialData?.eventConfig) {
      setEventName(initialData.eventConfig.eventName || '');
      setEventProperties(initialData.eventConfig.eventProperties || []);
      setLookbackPeriod(initialData.eventConfig.lookbackPeriod || '7');
      setLookbackUnit(initialData.eventConfig.lookbackUnit || 'days');
    }
  }, [initialData]);

  const handleSave = () => {
    const eventConfig = { eventName, eventProperties, lookbackPeriod, lookbackUnit };
    onSave(eventConfig);
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="drawer-backdrop" onClick={onClose}></div>}

      {/* Drawer */}
      <div className={`drawer ${isOpen ? 'drawer-open' : ''}`}>
        {/* Header */}
        <div className="drawer-header d-flex justify-content-between align-items-center border-bottom">
          <h5 className="m-0">Configure Event</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        {/* Content */}
        <div className="drawer-body">
          {/* Event Name */}
          <div className="mb-3">
            <label className="form-label">Event Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter event name"
              value={eventName}
              onChange={(e) => setEventName(e.target.value)}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="drawer-footer border-top p-3">
          <button className="btn btn-primary w-100" onClick={handleSave}>
            SAVE & CONTINUE
          </button>
        </div>
      </div>
    </>
  );
};

export default HasDoneEventDrawer;
